import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Event, NavigationEnd, Router, UrlSegment } from "@angular/router";
import { filter } from "rxjs/internal/operators/filter";
import type { Breadcrumb } from "../stores/route-breadcrumb.store";
import { BehaviorSubject, Observable } from "rxjs";

interface RouteData {
  breadcrumb?: string;
}

@Injectable({ providedIn: "root" })
export class RouteBreadcrumbService {
  private breadcrumbs = new BehaviorSubject<Breadcrumb[]>([]);

  constructor(private readonly router: Router) {}

  initialize(): void {
    this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe(() => {
      const breadcrumbs: Breadcrumb[] = this.buildBreadcrumb(this.router.routerState.snapshot.root);
      this.breadcrumbs.next(breadcrumbs);
    });
  }

  private buildBreadcrumb(route: ActivatedRouteSnapshot, rawUrl?: string, breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    let url = rawUrl ?? "";
    const children: ActivatedRouteSnapshot[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.url.map((segment: UrlSegment) => segment.toString()).join("/");
      if (routeURL !== "") {
        url += `/${routeURL}`;
      }

      const ownLabel = (child.routeConfig?.data as RouteData | undefined)?.breadcrumb;
      if (ownLabel) {
        const breadcrumb: Breadcrumb = {
          label: ownLabel,
          url: url,
        };

        if (breadcrumb.label.toLowerCase().includes("inicio")) {
          breadcrumb.url = "/home";
        }

        breadcrumbs.push(breadcrumb);
      }

      return this.buildBreadcrumb(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }

  get breadcrumbs$(): Observable<Breadcrumb[]> {
    return this.breadcrumbs.asObservable();
  }
}
